<template>
  <v-dialog
    v-model="showModal"
    width="500"
    persistent
    content-class="mainModal"
  >
    <v-card class="cardModal" elevation="0">
      <div class="input-wrapper textAreaModal">
        <h2 class="titleSection text-center">Nueva Version Encontrada</h2>
          <p>Se ha detectado una nueva versión a utilizar. Es requerido actualizar</p>
      </div>
      <div class="d-flex align-center justify-center">
          <v-btn
            color="primary"
            depressed
            @click="refresh()"
          >
            Actualizar
          </v-btn>
      </div>
    </v-card>
  </v-dialog>
</template>
<script>
  export default {
    props: {},
    data: () => ({
      newVersion: false
    }),
    computed: {
      showModal: function () {
        return this.newVersion || this.$store.state.system.newVersion
      }
    },
    methods: {
      refresh: () => {
        if ('caches' in window) {
          // Service worker cache should be cleared with caches.delete()
          caches.keys().then((names) => {
            names.forEach((name) => caches.delete(name))
          })
        }
        window.location.reload()
      }
    },
    created () {
    }
  }
</script>

<style lang="scss" scoped>
.cardModal{
  padding: 24px;
  p{
    text-align: center;
    margin-top: 15px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ReloadRequired.vue